import { CalendarDays, ExternalLink } from 'lucide-react';
import { useLang, useT } from '@/i18n';
import { bookingUrl, siteUrl } from '@/lib/siteUrl';

/* Выход из тренажёра наружу. Обе ссылки — в том языке, в котором человек
 * сейчас находится: язык живёт в URL, и сюда он приходит оттуда же.
 *
 * Стоит там, где прохождение уже закончилось (результаты, профиль). Внутрь
 * сцены не ставится: тренажёр сначала тренажёр, а продажа посреди упражнения
 * ломает и то и другое. */
export const AgencyLinks = ({ className = '' }) => {
  const lang = useLang();
  const t = useT();

  return (
    <div className={`flex flex-col items-center gap-2 ${className}`}>
      <a
        href={siteUrl(lang)}
        target="_blank"
        rel="noopener"
        className="inline-flex items-center gap-1.5 text-xs font-body text-muted-foreground hover:text-foreground transition-colors duration-150 text-center"
      >
        <ExternalLink size={13} className="shrink-0" />
        {t('ui.cta.site')}
      </a>
      <a
        href={bookingUrl(lang)}
        target="_blank"
        rel="noopener"
        className="inline-flex items-center gap-1.5 text-xs font-heading font-semibold text-primary hover:underline text-center"
      >
        <CalendarDays size={13} className="shrink-0" />
        {t('ui.cta.booking')}
      </a>
    </div>
  );
};
